import styled from 'styled-components';

export const Content = styled.div`
  th {
    vertical-align: middle;
    max-width: 120px;
    white-space: normal;
  }

  .label-cell {
    min-width: 180px;
    color: ${(props) => props.theme.$dark};
  }
`;
